import script from "./UPassRecovery.vue?vue&type=script&setup=true&lang=ts"
export * from "./UPassRecovery.vue?vue&type=script&setup=true&lang=ts"

import "./UPassRecovery.vue?vue&type=style&index=0&id=65e348c6&lang=css"

const __exports__ = script;

export default __exports__